/* eslint-disable no-param-reassign */

export const useBorderControl = () => {
  const calculateTextBorderLimits = ({obj, canvasWidth, canvasHeight}) => {
    if (obj.height > canvasHeight || obj.width > canvasWidth) {
      return obj;
    }

    if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
      obj.top = Math.max(obj.top, 0);
      obj.left = Math.max(obj.left, 0);
    }

    if (
      obj.top + obj.height * obj.scaleY > canvasHeight ||
      obj.left + obj.width * obj.scaleX > canvasWidth
    ) {
      obj.top = Math.min(obj.top, canvasHeight - obj.height * obj.scaleY);
      obj.left = Math.min(obj.left, canvasWidth - obj.width * obj.scaleX);
    }

    return obj;
  };

  const calculateImageBorderLimits = ({obj, canvasWidth, canvasHeight}) => {
    const {br, tl} = obj.aCoords;
    const imageWidth = br.x - tl.x;
    const imageHeight = br.y - tl.y;
    const minVisibleWidth = imageWidth * 0.5;
    const minVisibleHeight = imageHeight * 0.5;

    if (br.y < minVisibleHeight) {
      obj.top = obj.top - br.y + minVisibleHeight;
    }

    if (br.x < minVisibleWidth) {
      obj.left = obj.left - br.x + minVisibleWidth;
    }

    if (tl.y > canvasHeight - minVisibleHeight) {
      obj.top = obj.top - (tl.y - canvasHeight) - minVisibleHeight;
    }

    if (tl.x > canvasWidth - minVisibleWidth) {
      obj.left = obj.left - (tl.x - canvasWidth) - minVisibleWidth;
    }

    return obj;
  };

  const handleBorderLimits = (e) => {
    if (e.target && e.transform?.action === 'drag') {
      const obj = e.target;
      const {canvas} = e.target;
      if (!canvas) return;

      const canvasWidth = canvas.getWidth() / canvas.getZoom();
      const canvasHeight = canvas.getHeight() / canvas.getZoom();

      const calculateLimits =
        obj.type === 'textbox' ? calculateTextBorderLimits : calculateImageBorderLimits;
      calculateLimits({obj, canvasWidth, canvasHeight});

      obj.setCoords();

      canvas.fire('object:modified', {
        target: obj,
      });
    }
  };

  return {
    calculateTextBorderLimits,
    calculateImageBorderLimits,
    handleBorderLimits,
  };
};
